var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.chartId}},[(!_vm.chartData.length)?_c('a-empty',{staticStyle:{"padding-top":"48px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }